import { __extends, __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames, analyticsTracker } from 'uitk-react-utils';
import styles from './uitk-more-info-trigger.css';
import { UitkMoreInfoTriggerSizesArray, UitkMoreInfoTriggerWeightsArray, UitkMoreInfoTriggerThemesArray, UitkMoreInfoTriggerAlignsArray } from './types.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkMoreInfoTrigger = /** @class */ (function (_super) {
    __extends(UitkMoreInfoTrigger, _super);
    function UitkMoreInfoTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkMoreInfoTrigger.prototype.render = function () {
        var _a = this.props, children = _a.children, size = _a.size, weight = _a.weight, domRef = _a.domRef, theme = _a.theme, align = _a.align, className = _a.className, analytics = _a.analytics, props = __rest(_a, ["children", "size", "weight", "domRef", "theme", "align", "className", "analytics"]);
        var childrenArray = React.Children.toArray(children);
        var firstChild = childrenArray[0];
        var baseCssClass = 'uitk-more-info-trigger';
        var childClassName = getClassNameList(baseCssClass, "".concat(baseCssClass, "-size-").concat(size), "".concat(baseCssClass, "-weight-").concat(weight), "".concat(baseCssClass, "-theme-").concat(theme), "".concat(baseCssClass, "-align-").concat(align), className);
        if (!props.onClickCapture && analytics) {
            props.onClickCapture = analyticsTracker.bind(this, analytics);
        }
        firstChild = React.cloneElement(firstChild, firstChild.props, React.Children.map(firstChild.props.children, function (child) {
            if (!child) {
                return;
            }
            if (React.isValidElement(child) && child.type.displayName === 'UitkIcon') {
                return (React.createElement("div", { className: getClassNameList("".concat(baseCssClass, "-icon-container"), "".concat(baseCssClass, "-size-").concat(size, "-icon-container")), ref: domRef }, React.cloneElement(child, {
                    size: 'small',
                    className: getClassNameList("".concat(baseCssClass, "-icon"), "".concat(baseCssClass, "-icon-theme-").concat(theme))
                })));
            }
            return child;
        }));
        var decoratedChild = React.cloneElement(firstChild, __assign({ analytics: analytics, className: childClassName }, props));
        return decoratedChild;
    };
    UitkMoreInfoTrigger.displayName = 'UitkMoreInfoTrigger';
    UitkMoreInfoTrigger.defaultProps = {
        size: UitkMoreInfoTriggerSizesArray[UitkMoreInfoTriggerSizesArray.indexOf('medium')],
        weight: UitkMoreInfoTriggerWeightsArray[UitkMoreInfoTriggerWeightsArray.indexOf('regular')],
        theme: UitkMoreInfoTriggerThemesArray[UitkMoreInfoTriggerThemesArray.indexOf('default')],
        align: UitkMoreInfoTriggerAlignsArray[UitkMoreInfoTriggerAlignsArray.indexOf('leading')]
    };
    return UitkMoreInfoTrigger;
}(React.PureComponent));

export { UitkMoreInfoTrigger };
